import React, { useState } from "react";
import Image from "next/image";

interface AIChatbotSectionProps {
    sections: Section[];
}
interface Section {
    title: string;
    icon: string;
    title2: string;
    desc: string;
    img: string;
}

const AIChatbotSection: React.FC<AIChatbotSectionProps> = ({ sections }) => {
    const [currIndex, setCurrIndex] = useState(0);

    const handleBtnSelect = (index: number) => {
        setCurrIndex(index);
    };

    return (
        <section className="payments-spl-cont mt-20 mb-4 pb-8 md:mt-32 text-center hidden lg:block">
            <h2 className="pb-8 text-4xl font-bold" style={{ fontSize: "40px" }}>
                {sections[currIndex]?.title && (
                    <>
                        <h2 className="text-gray-700">Experience the Real Power of </h2>&nbsp;
                    </>
                )}
                <span className="text-blue-500">AI-Powered Chatbots</span>
            </h2>

            <div className="button-cont-ai flex-row hidden sm:hidden md:block pb-0">
                {sections.map((section, index) => (
                    <button key={section.title} onClick={() => handleBtnSelect(index)} className={`${currIndex === index ? "selected-button-ai" : "button-cont-ai-inactive"}`}>
                        <div className="flex row justify-center">
                            <Image width={16} height={16} src={section.icon} alt={`Icon ${index}`} className="button-icon w-5 h-5" />
                            <p style={{ marginLeft: "10px" }}>{section.title}</p>
                        </div>
                    </button>
                ))}
            </div>

            <div className="bg-blue-50">
                <div className="flex">
                    <div className="w-1/2 p-10 flex flex-col justify-center text-left">
                        <div className="mb-8">
                            <h3 className="font-bold text-4xl">{sections[currIndex]?.title2}</h3>
                            <p className="text-lg pt-4">{sections[currIndex]?.desc}</p>
                        </div>
                    </div>
                    <div className="w-1/2 flex justify-center items-center">
                        <div className="fi max-w-full max-h-full p-10">
                            <Image width={521} height={597} src={sections[currIndex]?.img} alt={`Image ${currIndex}`} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AIChatbotSection;
